import { useStrategiesContext } from './StrategiesContext';

import { GridWrapper } from './GridWrapper';
import { StrategyGridCard } from './StrategyGridCard';
import { useTranslation } from 'react-i18next';

export const Grid = () => {
  const { activeStrategies, inactiveStrategies, archivedStrategies } =
    useStrategiesContext();
  const { t } = useTranslation();

  return (
    <>
      {activeStrategies.length > 0 && (
        <GridCards title={t('strategies.activeStrategies')}>
          {activeStrategies}
        </GridCards>
      )}

      {inactiveStrategies.length > 0 && (
        <GridCards title={t('strategies.strategies')}>
          {inactiveStrategies}
        </GridCards>
      )}

      {archivedStrategies.length > 0 && (
        <GridCards title={t('strategies.archived')}>
          {archivedStrategies}
        </GridCards>
      )}
    </>
  );
};

function GridCards({ title, children }) {
  const { handleOnSelect } = useStrategiesContext();
  return (
    <>
      <h3 className="flex mt-8 text-lg font-semibold  dark:text-white">
        {title} ({children.length})
      </h3>
      <GridWrapper>
        {children.map((strategy, i) => (
          <StrategyGridCard
            key={strategy.id}
            showTooltip={i === 0}
            strategy={strategy}
            handleOnOptionSelect={handleOnSelect}
          />
        ))}
      </GridWrapper>
    </>
  );
}
